var map = {
	"./bicycles_hero_desktop.jpg": 504,
	"./bicycles_hero_mobile.jpg": 505,
	"./bicycles_hero_tablet.jpg": 506,
	"./coffee_hero_desktop.jpg": 507,
	"./coffee_hero_mobile.jpg": 508,
	"./coffee_hero_tablet.jpg": 509,
	"./flower_hero_desktop.jpg": 510,
	"./flower_hero_mobile.jpg": 511,
	"./flower_hero_tablet.jpg": 512,
	"./handbags_hero_desktop.jpg": 513,
	"./handbags_hero_mobile.jpg": 514,
	"./handbags_hero_tablet.jpg": 515,
	"./paper_hero_desktop.jpg": 516,
	"./paper_hero_mobile.jpg": 517,
	"./paper_hero_tablet.jpg": 518,
	"./semiconductors_hero_desktop.jpg": 519,
	"./semiconductors_hero_mobile.jpg": 520,
	"./semiconductors_hero_tablet.jpg": 521,
	"./spice_hero_desktop.jpg": 522,
	"./spice_hero_mobile.jpg": 523,
	"./spice_hero_tablet.jpg": 524,
	"./whisky_hero_desktop.jpg": 525,
	"./whisky_hero_mobile.jpg": 526,
	"./whisky_hero_tablet.jpg": 527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 503;